import {styled} from '@linaria/react';
import {COLORS} from '../../../constants/colors';

export const SkeletonBlock = styled.div<{
  $width?: `${number}${'%' | 'px'}`;
  $height?: `${number}${'px' | 'vh' | 'vw' | '%' | 'rem'}`;
  disableRoundedCorners?: boolean;
  disableSpaceBelow?: boolean;
  disableAnimation?: boolean;
}>`
  background: ${COLORS['Grey.Shade100']};
  position: relative;
  height: ${({$height}) => $height || '18px'};
  width: ${({$width}) => $width || '100%'};
  overflow: hidden;
  border-radius: ${({disableRoundedCorners}) =>
    !disableRoundedCorners ? '4px' : 'unset'};
  margin-bottom: ${({disableSpaceBelow}) => (!disableSpaceBelow ? '1rem' : 0)};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${COLORS['Grey.Shade200']},
      transparent
    );
    animation: ${({disableAnimation}) =>
      disableAnimation ? 'none' : 'shimmer 1.5s infinite'};
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%) skewX(-20deg);
    }
    100% {
      transform: translateX(100%) skewX(-20deg);
    }
  }
`;
